import { TeksCategory, TeksCurriculumUsage } from "@examspark/types";

export const TeksCategoryColors: Record<TeksCategory, string> = {
  PROCESS: "purple",
  READINESS: "red",
  SUPPORTING: "green",
  SEP: "purple",
  RTC: "orange",
};

export const TeksCategoryInitials: Record<TeksCategory, string> = {
  PROCESS: "P",
  READINESS: "R",
  SUPPORTING: "S",
  SEP: "P",
  RTC: "C",
};

export const TeksCurriculumUsageInitials: Record<TeksCurriculumUsage, string> =
  {
    DIRECTLY_TAUGHT: "T",
    DEVELOPING: "D",
    ONGOING: "O",
  };

export const TeksIndicatorInitials: Record<
  TeksCategory | TeksCurriculumUsage,
  string
> = {
  ...TeksCurriculumUsageInitials,
  ...TeksCategoryInitials,
};
